module.exports = __webpack_public_path__ + "img/21.8049b1e6.png";